import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import RichTextEditor from "react-rte";
import { Button } from "reactstrap";
import { API_END_POINT } from "../config";
import Cookie from "js-cookie";
import { JWT_SECRET_TOKEN } from "../config";
const jwt = require("jsonwebtoken");
import Select from "react-select";
import "react-select/dist/react-select.css";

// const token = Cookie.get("waffle_world_access_token");
// console.log("--->", Cookie.get("waffle_world_access_token"));
export default class AreaForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      category: {
        name: "",
        name_en: "",
        name_tr: "",
        name_ar: "",
        description: "",
        description_en: "",
        description_tr: "",
        description_ar: "",
        image: "",
      },
      gallery: "",
      city: "",
      cities: [],
      description: RichTextEditor.createEmptyValue(),
      token: localStorage.getItem("token"),
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.postCategory = this.postCategory.bind(this);
  }

  componentDidMount() {
    console.log("--->", this.state.token);
    const { match } = this.props;
    if (match.params.categoryId)
      axios
        .get(`${API_END_POINT}/api/categories/one`, {
          params: { categoryId: match.params.categoryId },
        })
        .then((response) => {
          let filteredCategory = response.data.object[0];
          delete filteredCategory["image"];
          this.setState({
            category: filteredCategory,
          });
        });
  }

  setDescription(description) {
    const { category } = this.state;
    category.description = description.toString("html");
    this.setState({
      category,
      description,
    });
  }

  setDescription_en(description_en) {
    const { item } = this.state;
    item.comment = description_en.toString("html");
    this.setState({
      item,
      description_en,
    });
  }

  setDescription_tr(description_tr) {
    const { item } = this.state;
    item.comment_tr = description_tr.toString("html");
    this.setState({
      item,
      description_tr,
    });
  }

  setDescription_ar(description_ar) {
    const { item } = this.state;
    item.comment_ar = description_ar.toString("html");
    this.setState({
      item,
      description_ar,
    });
  }

  handleInputChange(event) {
    const { value, name } = event.target;

    const { category } = this.state;
    category[name] = value;
    this.setState({ category });
  }

  setCity(selectedCity) {
    this.setState((prevState) => ({
      city: selectedCity,
      category: {
        ...prevState.category,
        city_id: selectedCity.ID,
        province: selectedCity.province,
      },
    }));
  }

  handleImages = (event) => {
    const { name } = event.target;
    const { category } = this.state;
    category[name] = event.target.files[0];
    this.setState({ category });
  };

  postCategory(e) {
    e.preventDefault();
    const { match, history } = this.props;
    const { category } = this.state;
    this.setState({ loading: true });
    const fd = new FormData();
    fd.append("name", category.name);
    fd.append("description", category.description);
    fd.append("image", category.image);

    if (!match.params.categoryId) {
      try {
        const tokenx = jwt.sign({ payload: fd }, JWT_SECRET_TOKEN, {
          expiresIn: "1h",
        });
        axios
          .post(`${API_END_POINT}/api/categories`, fd, {
            headers: { "auth-token": tokenx },
          })
          .then((res) => {
            console.log(res, "res");
            window.alert(res.data.msg);
            this.setState({ loading: false });
            this.props.history.goBack();
          });
      } catch (error) {
        console.log(error.message);
      }
    } else {
      fd.append("categoryId", match.params.categoryId);
      try {
        const tokenx = jwt.sign({ payload: fd }, JWT_SECRET_TOKEN, {
          expiresIn: "1h",
        });
        axios
          .post(`${API_END_POINT}/api/categories/update`, fd, {
            headers: { "auth-token": tokenx },
          })
          .then((res) => {
            console.log(res, "res");
            window.alert(res.data.msg);
            this.setState({ loading: false });
            this.props.history.goBack();
          });
      } catch (error) {
        console.log(error.message);
      }
    }
  }

  deleteImage = (url, ID) => {
    const data = { ID, url };
    let requestBody = { locationGallery: JSON.stringify(data) };
    if (confirm("Are you sure you want to delete this image?")) {
      // axios.delete(`${API_END_POINT}/api/delete/Image-deleteByPublicId`, {reqBody})
      axios
        .delete(`${API_END_POINT}/api/deleteGallery/category-deleteGallery`, {
          data: requestBody,
          headers: { Authorization: "token" },
        })
        .then((response) => {
          if (response.status === 200) {
            window.alert("Image deleted Successfully!");
          }
          // const category = this.state.category[gallery].slice();
          // category.splice(index, 1);
          // this.setState({ category });

          const { category } = this.state;
          category.gallery.splice(index, 1);
          this.setState({ category });
        });
    }
  };

  render() {
    console.log("this.state", this.state);
    const { loading, category, cities, city, description } = this.state;

    return (
      <div className="row animated fadeIn">
        <div className="col-12">
          <div className="row">
            <div className="col-md-12 col-sm-12">
              <div className="x_panel">
                <div className="x_title">
                  <h2>Kategorie Details eingeben</h2>
                </div>
                <div className="x_content">
                  <br />
                  <form
                    id="demo-form2"
                    data-parsley-validate
                    className="form-horizontal form-label-left"
                    onSubmit={this.postCategory}
                  >
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Kategorie Name
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name"
                          className="form-control"
                          value={category.name}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Kategorie Name Englisch
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name_en"
                          className="form-control"
                          value={category.name_en}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Kategorie Name Türkisch
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name_tr"
                          className="form-control"
                          value={category.name_tr}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Kategorie Name Arabisch
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="name_ar"
                          className="form-control"
                          value={category.name_ar}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Beschreibung
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="description"
                          className="form-control"
                          value={category.description}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Beschreibung Englisch
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="description_en"
                          className="form-control"
                          value={category.description_en}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Beschreibung Türkisch
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="description_tr"
                          className="form-control"
                          value={category.description_tr}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Beschreibung Arabisch
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="description_ar"
                          className="form-control"
                          value={category.description_ar}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                    {/* <div className="form-group row">
                      <label
                        className="control-label col-md-3 col-sm-3"
                      >Image
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="image"
                          className="form-control"
                          value={category.image}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div> */}

                    <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">
                        Bild
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="image"
                          className="form-control"
                          onChange={this.handleImages}
                          // multiple
                          required={
                            this.props.match.params.categoryId ? false : true
                          }
                        />
                      </div>
                    </div>

                    {/* <div className="form-group row">
                      <label
                        className="control-label col-md-3 col-sm-3"
                      >City
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="city"
                          className="form-control"
                          value={category.city}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div> */}

                    {/* <div className="form-group row">
                          <label className="control-label col-md-3 col-sm-3">City</label>
                          <div className="col-md-6 col-sm-6">
                            <Select
                              name="city_id"
                              value={city}
                              onChange={value => this.setCity(value)}
                              options={cities}
                              valueKey="id"
                              labelKey="name"
                              clearable={false}
                              backspaceRemoves={false}
                              required
                            />
                          </div>
                        </div> */}

                    {/* <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">Province</label>
                      <div className="col-md-6 col-sm-6">
                        <select
                          name="province"
                          value={category.province}
                          className="form-control custom-select"
                          onChange={this.handleInputChange}
                          required
                        >
                          <option value="">Select Type</option>
                          <option value="punjab">Punjab</option>
                          <option value="sindh">Sindh</option>
                          <option value="balochistan">Balochistan</option>
                          <option value="khyberPakhtunKhawa">Khyber PakhtunKhawa</option>
                          <option value="gilgitBaltistan">Gilgit Baltistan</option>
                          <option value="azadKashmir">Azad Kashmir</option>
                        </select>
                      </div>
                    </div> */}

                    {/* <div className="form-group row">
                      <label
                        className="control-label col-md-3 col-sm-3"
                      >Province
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          required
                          type="text"
                          name="province"
                          className="form-control"
                          value={category.province}
                          onChange={this.handleInputChange}
                          disabled={category.city_id ? 1 : 0}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label
                        className="control-label col-md-3 col-sm-3"
                      >Video Link
                      </label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          // required
                          type="text"
                          name="video_link"
                          className="form-control"
                          value={category.video_link}
                          onChange={this.handleInputChange}
                        />
                      </div>
                    </div> */}

                    {/* <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">Category Gallery</label>
                      <div className="col-md-6 col-sm-6">
                        <input
                          type="file"
                          accept="image/*"
                          name="cover"
                          className="form-control"
                          onChange={this.handleImages}
                          multiple
                          required={category.gallery ? 0 : 1}
                        />
                      </div>
                    </div> */}

                    {category.gallery ? (
                      <div className="form-group row">
                        <label className="control-label col-md-3 col-sm-3"></label>
                        <div className="col-md-6 col-sm-6">
                          {category.gallery.map((image, index) => {
                            return (
                              <span key={index}>
                                <img
                                  style={{ marginRight: "5px" }}
                                  width="100"
                                  className="img-fluid"
                                  src={`${image.url}`}
                                  alt="cover"
                                />
                                <span
                                  className="fa fa-trash"
                                  aria-hidden="true"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.deleteImage(image.url, category.ID)
                                  }
                                />
                              </span>
                            );
                          })}
                        </div>
                      </div>
                    ) : null}

                    {/* <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">Recommended</label>
                      <div className="col-md-6 col-sm-6">
                      <input
                        type="checkbox"
                        name='recommended'
                        checked={category.recommended}
                        onClick={() => {
                          category.recommended = !category.recommended;
                          this.setState({ category })
                        }}
                      />
                      </div>
                    </div> */}

                    {/* <div className="form-group row">
                      <label className="control-label col-md-3 col-sm-3">Description</label>
                      <div className="col-md-6 col-sm-6">
                        <RichTextEditor
                          value={description}
                          toolbarConfig={toolbarConfig}
                          onChange={(e) => {
                            this.setDescription(e);
                          }}
                        />
                      </div>
                    </div> */}
                    <div className="ln_solid" />
                    <div className="form-group row">
                      <div className="col-md-6 col-sm-6 offset-md-3">
                        <Button
                          className={`btn btn-success btn-lg ${
                            this.state.loading ? "disabled" : ""
                          }`}
                        >
                          <i
                            className={`fa fa-spinner fa-pulse ${
                              this.state.loading ? "" : "d-none"
                            }`}
                          />
                          &nbsp; Bestätigen
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/CategoryForm.jsx